exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header---1XkWH {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  min-width: 0; }\n  .header---1XkWH h2 {\n    color: #415667;\n    font-size: 25px;\n    max-width: calc(100% - 16px);\n    font-weight: 500;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  .header---1XkWH .date-range---3Fvt_ {\n    display: block;\n    float: left;\n    clear: both;\n    font-size: 16px;\n    color: #1981c4; }\n  .subheader---1kVbr {\n  text-wrap: wrap; }\n", ""]);

// exports
exports.locals = {
	"header": "header---1XkWH",
	"date-range": "date-range---3Fvt_",
	"subheader": "subheader---1kVbr"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/sub-heading/sub-heading-header/sub-heading-header.scss
// module id = lZfO
// module chunks = 1